import React from "react";
import login from "../../../assets/authentication/bg.jpg";
import logo from "../../../assets/authentication/logo1.svg";
import { useFormik } from "formik";
// import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, createTheme, TextField, ThemeProvider } from "@mui/material";
import { toast } from "react-toastify";
import axiosInstance from "../../../config/axios";

const GeneratePassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const lightTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#1345B7",
      },
    },
  });

  const initialValues = {
    email: state.email,
    otp: "",
    password: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values, action) => {
      const reqBody = {
        email: values.email,
        password: values.password,
        otp: values.otp,
      };
      axiosInstance
        .post(
          `api/admin/verify-otp-multivendor-forget-password-admin/`,
          {
            ...reqBody,
          },
          {
            headers: {
              Token: "7bb1993fa3eec237daf4362b07f035e71f0ff5ef",
            },
          },
        )
        .then((response) => {
          toast.success(response.data.message);
          navigate("/");
        })
        .catch((error) => {
          console.log("", error.response);
          console.log(error);
        });
    },
  });

  return (
    <>
      <div className="flex">
        <img
          src={login}
          alt=""
          className="h-screen fixed object-cover w-screen"
        />
        <div className="flex z-[999] flex-col h-screen justify-center items-center p-16 text-black w-[30%] border-r-2 border-opacity-20 bg-white bg-opacity-10 backdrop-blur-md">
          <img src={logo} alt="" className="h-28" />
          <div>
            <p className="text-xl mt-10 text-left">Create New Password</p>
            <p className="my-2 text-xs">
              Enter your email address and we’ll send you an email with
              instructions to reset your password
            </p>
          </div>

          <form
            onSubmit={formik.handleSubmit}
            className="flex flex-col w-full my-2"
          >
            <ThemeProvider theme={lightTheme}>
              <label className="py-1">otp</label>
              <TextField
                id="otp"
                name="otp"
                size="small"
                placeholder="otp"
                value={formik.values["otp"]}
                onChange={formik.handleChange}
                onBlur={formik.onBlur}
                type="otp"
                className="rounded-md text-black px-2 p-2 focus:!outline-none !border-2 bg-white bg-opacity-20 backdrop-blur-sm"
              />

              <label className="py-1">New Password</label>
              <TextField
                id="password"
                name="password"
                size="small"
                placeholder="password"
                value={formik.values["password"]}
                onChange={formik.handleChange}
                onBlur={formik.onBlur}
                type="password"
                className="rounded-md text-black px-2 p-2 focus:!outline-none !border-2 bg-white bg-opacity-20 backdrop-blur-sm"
              />

              <div className="flex mt-5">
                <Button
                  disableElevation
                  variant="contained"
                  type={"submit"}
                  className="px-10 !rounded-md !p-1.5 !capitalize !mx-0"
                >
                  Sent
                </Button>
              </div>
            </ThemeProvider>
          </form>
        </div>
      </div>
    </>
  );
};

export default GeneratePassword;
